// extracted by mini-css-extract-plugin
export default {"startAdornmentBorder":"CounterInputControl_startAdornmentBorder__j9YSN","textCenter":"CounterInputControl_textCenter__tK6TG"};